import http from '../http-common';

const preview = (date, count, seed) => {
    const params = { date };
    if (count !== undefined && count !== null) {
        params.count = count;
    }
    if (seed !== undefined && seed !== null) {
        params.seed = seed;
    }
    return http.get('/v1/entries/missing-exits/preview', { params });
};

const generate = ({ date, count, seed, adminId }) => {
    return http.post('/v1/entries/missing-exits/generate', {
        date,
        count,
        seed,
        adminId,
    });
};

export default {
    preview,
    generate,
};
